import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import "./download-clipped-coupons.scss";
import { getLocalStorageValue } from 'config/helper';
import { getCustomerDetails } from 'redux/actions';

const DownloadCartItems = React.forwardRef(({ couponCartList}, ref) => {
    const customerData = useSelector(({ customer }) => customer.customerlistData);
    const { currentStoreID } = useSelector(({ store }) => store);
    const dispatch = useDispatch();

    const clientId = getLocalStorageValue("RSAclient-id");
    const userToken = getLocalStorageValue("user-token");
    const memberNumber = getLocalStorageValue("member-number");
    const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
    const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

    useEffect(() => {
        if (!userToken || !memberNumber || !clientId) return

        const body = {
          RSAClientId: clientId,
          ClientStoreId: storeId,
          AppName: isUserLoggedIn ? "shop" : "",
          member_number: isUserLoggedIn ? memberNumber : "",
          user_token: isUserLoggedIn ? userToken : "",
          Version: isUserLoggedIn ? "1" : "",
          DeviceType: isUserLoggedIn ? "web" : ""
        };
        dispatch(getCustomerDetails(body));
      }, []); // eslint-disable-line

    const barcodeImage =  getLocalStorageValue("user-barcode");
     return (
        <>
            {couponCartList.length > 0 && (
                <div className="download-coupon-cart-items-table" ref={ref}>
                    <div className="download-coupon-cart-section-align">
                        <div className="download-coupon-cart-title">
                            <h3>{customerData?.first_name} {customerData?.last_name}</h3>
                        </div>
                        <div className="download-coupon-cart-title">
                            <h2>Clipped Coupons</h2>
                        </div>
                        <div className="download-coupon-page-grid-align">
                            <div>
                                <p>
                                    There are{" "}
                                    {couponCartList.length > 0 ? couponCartList.length : "0"} coupons
                                    clipped.
                                </p>
                            </div>
                        </div>
                    </div>
                    <img alt="Barcode"
                                      src={barcodeImage ?  barcodeImage:''}
                                                                    style={{ marginLeft: '108px' }}
                                                                   
                                                                />
              
                    <table className="download-coupon-cart-table">
                        <thead>
                            <th></th>
                            <th className="title">Title</th>
                            <th>Use(times)</th>
                        </thead>
                        <tbody>
                            {couponCartList.map((coupon, index) => {
                                const { image_path, title } = coupon;
                                return (
                                    <tr key={index}>
                                        <td data-label="Image">
                                            <img src={image_path} alt="CouponImage" />
                                        </td>
                                        <td data-label="Title" className="title">
                                            {title}
                                        </td>
                                        <td data-label="Limit">{1}</td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
});
export default DownloadCartItems;
